export default __webpack_public_path__ + "static/media/gameKnight.15f2da79.png";